import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy: /app/operaciones/compras duplicaba la supply chain.
 * Redirige a las OC de proveedores en /app/compras/ordenes.
 */
export const Route = createFileRoute("/app/operaciones/compras")({
  beforeLoad: () => {
    throw redirect({ to: "/app/compras/ordenes", search: {} as never });
  },
});
